import * as React from 'react';
import { useLocation, useNavigate } from "react-router-dom";
import Box from '@mui/material/Box';
import Drawer from '@mui/material/Drawer';
import CssBaseline from '@mui/material/CssBaseline';
import AppBar from '@mui/material/AppBar';
import Toolbar from '@mui/material/Toolbar';
import List from '@mui/material/List';
import Divider from '@mui/material/Divider';
import ListItem from '@mui/material/ListItem';
import ListItemButton from '@mui/material/ListItemButton';
import ListItemText from '@mui/material/ListItemText';
import Collapse from '@mui/material/Collapse';
import styles from "./navBar.module.scss";
import { Grid } from '@mui/material';
import Loader from '../Loader';
import { useDispatch, useSelector } from 'react-redux';
import Nudge from '../Nudge';
import { hideNavHeadersAction, showNavHeadersAction } from './navBarReducer';
import { hideSummaryAction as campaignSummaryHideAction } from '../CampaignSummary/campaignSummaryReducer';
import { hideSummaryAction as segmentSummaryHideAction } from '../SegmentSummary/segmentSummaryReducer';
import { setIsClone, setViewCampaignSelected } from '../../containers/CreateCampaigns/createCampaignReducer';
import { updateViewTab } from '../../containers/ViewCampaigns/viewCampaignReducer';
import { CAMPAIGN_VIEW_TAB } from '../../containers/ViewCampaigns/constants';
import logo from '../../assets/logo.svg'
import { routes } from '../../utils/constants';
import CampaignInfo from './CampaignInfo';
import SegmentInfo from './SegmentInfo';

var user = localStorage.getItem("user");
user = JSON.parse(user)
const drawerWidth = 240;

const NavBar = ({ children }) => {
    const { showNavHeaders } = useSelector(store => store.navbar)
    const campaignSummary = useSelector(store => store.campaignSummary)
    const segmentSummary = useSelector(store => store.segmentSummary)
    const navigate = useNavigate()
    const location = useLocation()
    const dispatch = useDispatch()
    const nestedMenu = {
        Campaigns: {
            state: React.useState(true),
            items: [{
                label: "Create Campaign",
                route: routes.createCampaign
            },
            {
                label: "View Campaigns",
                route: "/"
            }],
            onClick: () => {
                dispatch(hideNavHeadersAction())
                dispatch(setIsClone(false))
            }
        },
        "Customer Segment": {
            state: React.useState(true),
            items: [{
                label: "Create Segments",
                route: routes.createSegments
            },
            {
                label: "View Segments",
                route: routes.viewSegments
            }],
            onClick: () => {
                dispatch(showNavHeadersAction())
                dispatch(setIsClone(false))
            }
        }
    }

    const handleCollapseMenuOpen = (key) => {
        const state = nestedMenu[key].state[0]
        const setStateHandler = nestedMenu[key].state[1]
        setStateHandler(!state)
    };

    const listItemOnClick = (route) => {
        navigate(route)
        dispatch(campaignSummaryHideAction())
        dispatch(setViewCampaignSelected(null))
        dispatch(segmentSummaryHideAction())
    }

    const renderHeaderComp = () => {
        const components = []
        if (showNavHeaders) {
            if (campaignSummary.showSummary || campaignSummary.summary) {
                components.push(<CampaignInfo summary={campaignSummary.summary} />)
            } else {
                components.push(<SegmentInfo showSummary={segmentSummary.showSummary} summary={segmentSummary.summary} />)
            }
            components.push(<Grid item xs={5} />)
        } else {
            components.push(<Grid item xs={9} />)
        }

        return components
    }

    return (
        <Box sx={{ display: 'flex', bgcolor: '#E5E5E5' }}>
            <CssBaseline />
            <AppBar
                position="fixed"
                sx={{ width: `calc(100% - ${drawerWidth}px)`, ml: `${drawerWidth}px`, boxShadow: "none", borderBottom: showNavHeaders ? "unset" : "1px solid #E5E5E5" }}
            >
                <Toolbar classes={{ root: styles.toolbarRoot }} >
                    <Grid container>
                        {renderHeaderComp()}
                        <Grid container item xs={3} justifyContent="end" className={styles.profileText}>
                            <Grid item xs={12} className={styles.text}>
                                Welcome, {user.given_name} {user.family_name}
                            </Grid>
                            <Grid item xs={12} className={styles.logoutText}>
                                You are logged in as {user.email} | <span className={styles.logout} onClick={() => {
                                    localStorage.clear()
                                    window.location.reload()
                                }}>Logout</span>
                            </Grid>
                        </Grid>
                    </Grid>
                </Toolbar>
            </AppBar>
            <Drawer
                sx={{
                    width: drawerWidth,
                    flexShrink: 0,
                    '& .MuiDrawer-paper': {
                        width: drawerWidth,
                        boxSizing: 'border-box',
                    },
                }}
                variant="permanent"
                anchor="left"
            >
                <Toolbar >
                    <img onClick={() => {
                        navigate("/")
                    }} src={logo} height="63px" width="100%" />
                </Toolbar>
                <Divider />
                <List component={"nav"}>
                    {Object.keys(nestedMenu).map(key => (
                        <div key={key}>
                            <ListItem classes={{
                                root: styles.parentNav
                            }} disablePadding>
                                <ListItemButton onClick={() => {
                                    handleCollapseMenuOpen(key)
                                }}>
                                    <ListItemText primary={key} />
                                </ListItemButton>
                            </ListItem>
                            {!!nestedMenu[key].items.length && <Collapse in={nestedMenu[key].state[0]} timeout="auto" unmountOnExit>
                                <List component="div" disablePadding>
                                    {nestedMenu[key].items.map((nestedItem, index) => (
                                        <ListItem classes={{
                                            selected: styles.selected
                                        }} key={nestedItem.label} disablePadding selected={location.pathname === nestedItem.route}>
                                            <ListItemButton sx={{ pl: 6 }} onClick={() => {
                                                if (location.pathname !== nestedItem.route) {
                                                    listItemOnClick(nestedItem.route)
                                                    nestedMenu[key].onClick()
                                                    dispatch(updateViewTab({type:CAMPAIGN_VIEW_TAB.all, page:0}))
                                                }  
                                            }}>
                                                <ListItemText primary={nestedItem.label} />
                                            </ListItemButton>
                                        </ListItem>
                                    ))}
                                </List>
                            </Collapse>}
                        </div>
                    ))}
                </List>
            </Drawer>
            <Box
                className={styles.main}
                component="main"
                sx={{ flexGrow: 1, marginTop: 6.5, bgcolor: '#E5E5E5', p: 0 }}
            >
                {children}
                <Loader />
                <Nudge />
            </Box>
        </Box>
    );
}
export default NavBar